import {Companies} from "./models.js";

function Facility() {

    // Integer
    const level = 1;
    const actionsCompleted = 0;

    // Strings
    const name = null;

    // Boolean
    const staffNeverHired = true;

    // Foreign keys
    const companyId = null;

    return {
        level,
        actionsCompleted,
        name,
        staffNeverHired,
        companyId,
    };
}

function getFacilityCompany(facility) {
    return Companies.find({'$loki': facility.companyId})[0];
}


export { Facility, getFacilityCompany }
